<template>
  <section>
    <!-- 智慧政务 -->
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col cols="12" sm="10" md="9" xl="8">
          <div class="wisdom-gov">
            <b-tabs
              content-class="mt-3"
              @input="changeTopTab"
              class="wisFirstTab"
            >
              <b-tab
                v-for="(item, index) in tabsData"
                :key="index"
                :title="item.tabsTitle"
                :active="item.tabsTitle == tabTopName"
              >
                <div class="tabBox">
                  <b-tabs
                    pills
                    card
                    vertical
                    v-model="tabIndex['active' + index]"
                  >
                    <b-tab
                      v-for="eve in item.listShow"
                      :key="eve.id"
                      :title="eve.name"
                      :active="eve.name== tabLeftName "
                      >
                      <div>
                        <!-- <h3 class="mobileTitle">{{ eve.name }}</h3> -->
                        <h3 class="mobileTitle">{{ eve.boxData.title }}</h3>
                        <p
                          class="Wis-context"
                          v-for="(itemP, index) in eve.boxData.text"
                          :key="index"
                          style="text-align: justify"
                        >
                          {{ itemP.p }}
                        </p>
                        <div class="show-Img">
                          <span
                            class="pageUp"
                            v-show="pageUpDown"
                            @click="tabIndex['active' + index]--"
                          ></span>
                          <img
                            :src="eve.boxData.img"
                            :style="personalImg"
                            alt=""
                          />
                          <span
                            class="pageDown"
                            v-show="pageUpDown"
                            @click="tabIndex['active' + index]++"
                          ></span>
                        </div>
                        <!-- 常规轮播 -->
                        <!-- <el-carousel
                          indicator-position="outside"
                          arrow="always"
                          v-show="eve.boxData.title !== '整合共享项目'"
                        >
                          <el-carousel-item
                            v-for="(imgs, index) in eve.boxData.imgs"
                            :key="index"
                          >
                            <img :src="imgs.img" alt="" />
                          </el-carousel-item>
                        </el-carousel> -->
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import Sub_banner from "../sub-banner.vue";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  data() {
    return {
      tabTopName:'',
      tabLeftName:'',
      subBannerInfo: {
        img: require("@/assets/images/e-gov_banner.png"),
        title: "智慧政务",
        subTitle: "Smart government services",
      },
      pageUpDown: true, //切换二级tabs的左右按钮是否显示
      // 专为飞行标准监督管理写个样式(FSOP)
      personalImg: "",
      // 二级tab的当前选中值
      tabIndex: {
        active0: 0,
        active1: 0,
        active2: 0,
      },
      tabsData: [
        
      ],
    };
  },
  watch: {
    // "tabIndex.active0": function (newVal, oldVal) {
    //   console.log(newVal, oldVal);
    //   if (newVal === 1) {
    //     this.personalImg = "width: 100%;margin-left: -8%;";
    //   } else {
    //     this.personalImg = "";
    //   }
    // },
  },
 
  mounted(){
    this.tabTopName = !this.$route.query.tabTop ?'安全监管' : this.$route.query.tabTop
      this.tabLeftName = !this.$route.query.title ? '飞行标准监督管理(FSOP)' : this.$route.query.title
      this.getData();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      let screenWidth = window.innerWidth;
      this.setReSize(screenWidth);
    };
    this.setReSize(window.innerWidth);
  },
  methods: {
    changeTopTab(tabIndex) {
      let SecTabLen = this.tabsData[tabIndex].listShow.length;
      if (SecTabLen <= 1) {
        this.pageUpDown = false;
      } else {
        this.pageUpDown = true;
      }
    },
    getData(){
      this.tabsData = [{
          id: "1",
          tabsTitle: "安全监管",
          listShow: [
            {
              id: "1-1",
              name: "飞行标准监督管理(FSOP)",
              boxData: {
                title: "飞行标准监督管理(FSOP)",
                text: [
                  {
                    p: "飞行标准监督管理（FSOP）系统是民航局安全监管首个信息化平台，由27个子系统有机组成，覆盖民航21部规章及200余个规范性文件。各系统协同共享，实现了对飞行标准监管业务的全面覆盖，对行政相对人运行合格审定和持续监督检查，形成了体系完备、功能齐全、有效联动的统一的飞行标准监管应用群。系统用户涉及局方、航空公司、保障机构、航空人员近40余万。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/FSOP-all3.png"),
              },
            },
            {
              id: "1-2",
              name: "民用机场安全监管(ASOP)",
              boxData: {
                title: "民用机场安全监管(ASOP)",
                text: [
                  {
                    p: "民用机场安全监管（ASOP）系统2018年投入使用，包括民用机场使用许可、机场行政检查、监管数据统计、飞行区报告等模块，实现了机场监管业务在线制定、任务分配、检查实施、问题处理，跟踪闭环，机场使用许可在线申请、受理、审查、决定、颁证，监管数据统计等功能。系统主要覆盖局方监察员、机场行政相对人等用户，实现民用机场使用许可、机场安全检查全面电子化，实现机场飞行区快报、周报、月报的统一上报汇总，极大提升了机场安全管理效率和人员能力管控。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/ASOP-2.png"),
                // imgs: [
                //   {
                //     img: require("@/assets/images/wisdom-gov/ASOP.png"),
                //   },
                // {
                //   img: require("@/assets/images/e-gov/wisdomImgs/ASOP1.png"),
                // },
                // {
                //   img: require("@/assets/images/e-gov/wisdomImgs/ASOP2.png"),
                // },
                // ],
              },
         
            },
            {
              id: "1-3",
              name: "民航行业监管执法系统(SES)",
              boxData: {
                title: "民航行业监管执法系统(SES)",
                text: [
                  {
                    p: "民航行业监管执法系统（SES）是贯彻落实“依法治国”的重要举措，支撑民航行业监管模式改革创新，实现了行政检查与法律支持的紧密结合，统一并规范了执法程序和法律文书格式等。该系统涉及12个司局23个专业6900多项检查事项，涵盖了1400余部法律、法规、规章、规范性文件及国际公约等。有效为精准监管、智慧监管提供了基础技术保障。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/SES.png"),
              },
            },
            {
              id: "1-4",
              name: "适航管理系统（AMOS）",
              boxData: {
                title: "适航管理系统（AMOS）",
                text: [
                  {
                    p: "AMOS 系统建设深入贯彻“互联网+适航”的建设理念，构建了基于风险管理的审定模式，围绕辅助审定、审定业务管理、人员管理、证件管理四大业务，对我国适航信息化体系进行优化、整合，建成了航空器从设计、生产、改装、单机适航、部件审定、航空消耗品审定到部分持续适航功能的全链条管理，实现了审定工作的信息化、流程化和标准化。系统覆盖了20余项行政许可管理，涉及3千个用户，也是民航局第一个对接电子印章/证照和好差评的系统，充分践行“真情服务”的理念。",
                  },
                  {
                    p: "AMOS进行了全面国产化的探索，服务器、软件和数据库均采用国内拥有自主知识产权的产品，是名副其实的“中国心”，确保了系统高效安全、自主可控。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/AMOS.png"),
              },
            },
            {
              id: "1-5",
              name: "民用无人驾驶航空器综合管理平台（UOM）",
              boxData: {
                title: "民用无人驾驶航空器综合管理平台（UOM）",
                text: [
                  {
                    p: "为了落实国家《无人驾驶航空器飞行管理暂行条例》及民航局即将颁布的CCAC92部规章，UOM围绕行业管理、运行管理、政府协作、社会服务四大功能，创新民用无人驾驶航空器社会协同、分级分类管理模式，全面推进基于风险评估的管理理念，实现“飞起来、看得见、找得到”立体化、全方位的管控目标，为推动我国低空飞行服务的产业发展和应用、推动大众消费，提供安全服务和重要保障。",
                  },
                  {
                    p: "UOM是民航第一个使用人脸识别技术的政务系统，真正做到了“实名”认证。目前，实名登记系统、操控员资质系统已上线运行，运营合格审定、适航审定子系统、运行管理系统等将陆续开发上线。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/UOM.png"),
              },
            },
          ],
        },
        {
          id: "2",
          tabsTitle: "市场监管",
          listShow: [
            {
              id: "2-1",
              name: "民航综合统计信息系统",
              boxData: {
                title: "民航综合统计信息系统",
                text: [
                  {
                    p: "通过建设民航综合统计信息系统，建立统一的民航行业统计信息处理平台，实现对民航行政机关、民航企事业单位等综合统计资料的全面采集，实现在网络环境下进行统计规划和数据采集、处理、存储、分析、发布等全过程的高效处理。高度保障统计资料的真实性、准确性、及时性和完整性，有效落实民航行业统计调查工作，充分发挥统计在民航改革与发展中的信息咨询、决策支持和监督作用。系统应用效果呈现四个显著特点：综合各类数据、统计经济运行、信息全面展现、系统集约管理。首先，综合各类数据。通过系统统一采集机场、运输航空、通用航空、各司局专业统计、外部数据等多个类别的675个字段信息，实现了各类统计数据资源的整合；第二，统计经济运行。通过分析454个不同类别的统计指标，反映行业经济运行情况和行业发展趋势，为行业监管提供了重要的参考依据；第三，实现了信息全面展现。采用多种技术手段，深挖数据价值，可提供统计月报、统计年报、数据可视化、灵活查询、定制分析等多种功能，充分满足不同类型的统计分析需求；第四，系统集约管理。突出平台和统一的指导原则，将基础代码、业务规则、接口标准等统计业务元素集中在系统平台进行统一管理，进一步提升了统计数据质量和系统运行效率。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/total.png"),
              },
            },
            {
              id: "2-2",
              name: "民航价格管理系统",
              boxData: {
                title: "民航价格管理系统",
                text: [
                  {
                    p: "建立一套民航价格数据采集、整合、服务和管理的技术体系，及时准确掌握民航各类价格信息，为民航价格管理部门提供价格实时监测、预测、预警、监管、分析等支持，提高民航行业价格、收费执行情况监测能力，进一步加强民航价格及航空运输市场监管能力，增强和改善市场宏观调控能力，提高政府价格决策科学水平，促进民航行业持续健康有序发展。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/price.png"),
              },
            },
          ],
        },
        {
          id: "3",
          tabsTitle: "公共服务",
          // tabsTitle: "行政办公及公共服务",
          listShow: [
            {
              id: "3-1",
              name: "民航e政",
              boxData: {
                title: "民航e政",
                text: [
                  {
                    p: "2021年7月8日，民航局首个自主建设、安全可靠的移动综合办公平台——“民航e政”APP正式上线启动。该应用是以信息化为手段开启民航智慧政务建设、支撑行政办公转型的重要智能化举措，推动民航局行政办公从无纸化向移动化进阶、从电子化向智能化转型，是思维理念和工作方式的一次深刻变革，是用数字政府建设推进智慧民航发展的探索与实践。",
                  },
                  {
                    p: "2021政府信息化大会上，《民航电子政务移动办公系统“民航e政”》案例荣获“2021政府信息化卓越贡献奖”。",
                  },
                  {
                    p: "“民航e政”客户端包括移动端和电脑端，主体功能涵盖了移动办文、即时通讯、云会议以及工作圈、任务管理、会务管理、通知、直播等应用，目前已有近三千名民航各级行政机关公务员使用。后续，“民航e政”将不断充实完善系统功能，助力创新数字政府建设。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/ez3.png"),
              },
            },
            {
              id: "3-2",
              name: "民航局政府网站",
              boxData: {
                title: "民航局政府网站",
                text: [
                  {
                    p: "2016年，新版民航局政府网站上线运行，网站包括中文版、英文版、移动客户端以及移动浏览器版四大平台。民航局政府网站按照信息公开、办事服务、互动交流三大功能定位，统筹规划栏目设置，辅以多元化的互联网服务渠道，全面提升网站功能。同时，持续完善行政审批网上办事服务能力、优化站内检索和导航功能、改善公众交流渠道、增强政务信息公开力度。信息中心统筹集约行业信息数据资源，形成了民航局、地区管理局、部分直属单位网站资源管理平台的整合升级，规模化网站群，提升了民航服务社会公众的水平，凸显民航政府门户平台的公众服务功能",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/gov.png"),
              },
            },
            {
              id: "3-3",
              name: "民航行政审批服务平台",
              boxData: {
                title: "民航行政审批服务平台",
                text: [
                  {
                    p: "2020年，民航行政审批服务平台上线运行，平台按照民航局工作部署建设了服务门户（PC端/APP端/微信服务号）、工作门户、受理办理、事项库管理、“好差评”等7个功能模块，可为行政相对人提供全面、高效、统一的行政审批服务，并实现与国家一体化政务服务平台数据互通，为进一步提升民航局行政审批服务规范化便利化水平、提高办事效率提供强有力的信息化支撑。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/govcheck.png"),
              },
            },
            {
              id: "3-4",
              name: "民航电子证照系统 ",
              boxData: {
                title: "民航电子证照系统",
                text: [
                  {
                    p: "2021年，民航电子证照系统上线运行，该系统是为社会公众提供民航局统一的电子证照制发、核验、共享服务的共性应用支撑平台，通过建设电子证照综合管理、电子证照库、移动端卡包等功能，实现对行政相对人、公众服务电脑端、移动端的全覆盖，方便群众通过各种渠道对电子证照进行统一查询、统一核验以及统一公开，并在民航电子证照系统建设过程中实现与民航行政审批服务平台的全面集成融合。民航电子证照系统通过与民航电子印章系统对接，实现民航电子证照系统产生的证照在全国范围内的互信互认，可有效支撑民航电子证照数据安全、稳定、可靠的共享。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/e_pic.png"),
              },
            },
            {
              id: "3-5",
              name: "综合办公系统 ",
              boxData: {
                title: "综合办公系统",
                text: [
                  {
                    p:"2022年3月，新版民航电子政务综合办公系统在民航各级行政机关正式上线运行。系统建设秉持了功能易用性、界面友好性、系统安全性的设计思路，创新推出了“智能检索”、“统计分析”、“个性化首页自定义”等功能模块。同时，作为民航电子政务内网的统一门户和工作平台入口，在日常办文功能的基础上，支撑了全国航班运行数据统计平台建设，首次完成民航运行数据和政务数据融合，实现了依托综合办公系统对运行态势数据的共享利用和综合查询。丰富办事功能，全面提升办文、行政办事等应用服务水平，不断提高机关运行效能。后续，将持续完善系统功能，进一步提升行政办公效能，助力数字机关、数字政府、智慧民航建设。"
                  },
                ],
                img: require("@/assets/images/wisdom-gov/zhbg.png"),
              },
            },
          ],
        },

        {
          id: "4",
          tabsTitle: "云平台",
          // tabsTitle: "一体化政务信息系统云平台",
          listShow: [
            {
              id: "4-1",
              name: "民航政务信息系统整合共享项目",
              boxData: {
                title: "民航政务信息系统整合共享项目",
                text: [
                  {
                    p: "推进政务信息系统整合共享，是党中央国务院的重大决策部署，是推进国家治理能力现代化的重要手段。为落实国务院关于推进国家大数据战略、“放管服”、“互联网+政务服务”、政务信息系统整合共享、“互联网+监管”等工作精神，根据中国民用航空局下发的《民航政务信息系统整合共享实施方案》、《关于推进民航政务信息系统整合共享工作方案（2019-2020）》等要求，民航局信息中心以“大平台、大数据、大系统”为项目总体架构，开展了基于大数据技术的民航数据共享交换平台建设工作。",
                  },
                  {
                    p: "民航数据共享交换平台全面接入民航政务数据资源，打破了民航政务信息化“信息孤岛、各自为政”的局面，消除了民航局内部、民航局与其它行政机构之间的数据共享交换障碍，实现了跨地区、跨层级、跨部门的数据共享交换，填补了行业内在该领域内的空白。该平台自2020年底建成上线以来，充分发挥民航政务数据资源共享交换枢纽作用，实现了民航与国家平台之间、民航各政务信息系统之间的共享交换，在提高民航行政审批服务效率，实现“互联网+监管”政策要求，促进民航政务数据共享交换，提升行业治理能力等方面发挥了重要作用，同时为疫情防控的数据交换工作提供了重要数据支撑。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/bigData.png"),
              },
            },
            {
              id: "4-2",
              name: "民航政务云服务平台",
              boxData: {
                title: "民航政务云服务平台",
                text: [
                  {
                    p: "民航政务云服务平台实现了信息中心主数据中心以及同城灾备两个数据中心计算资源、存储资源，网络资源以及安全资源的深度融合、统一管理。民航政务云服务平台具有CPU8224核，内存27TB以及存储420余TB，运行虚拟机900余台，具备了IAAS层、PAAS层以及容器等业界主流云服务平台相关功能，为民航新基建提供了基础算力。民航政务云服务平台实现了民航各政务信息系统在大平台集中运行，切实避免各自为政、重复投资、重复建设，为民航新基建提供了基础算力，为行业应用系统提供基础设施保障。未来将进一步打造成服务全行业、统筹共用、自主可控的国家级民航云计算平台。",
                  },
                ],
                img: require("@/assets/images/wisdom-gov/e-service.png"),
              },
            },
          ],
        },
      ]
    },
    setReSize(screenWidth) {
     
      if (screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/e-gov_banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/e-m.png");
      }
      
     
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/wisdom-gov.css";
</style>
<style lang="less">
@media (max-width: 575px) {
  .mobileTitle {
    margin-top: 20px;
    font-size: 14px;
  }
  .wisdom-gov {
    padding-top: 50px;
    padding-bottom: 50px;
    .wisFirstTab {
      .nav-tabs {
        .nav-item {
          a.nav-link {
            padding: 0 20px;
            font-size: 14px;
          }
          font-size: 14px;
        }
      }
    }
  }
  .wisdom-gov .tab-content.mt-3 {
    // padding: 0 50px;
    > .tab-pane {
      padding: 0 40px;
    }
    .tabBox {
      margin-top: 30px;
      .tabs {
        width: 100%;
        flex-direction: column;
        .nav-pills {
          margin: 0;
          overflow: hidden;
          background: none;
          border-right: 1px solid #bfbfbf;
          margin: 0 auto !important;
          margin-right: 0px;
          .nav-item {
            a {
              font-size: 14px;
            }
            width: calc(100vw - 80px);
          }
          .nav-link {
            // height: 40px;
          }
          .active {
            // height: 50px;
          }
          .nav-item:hover {
            transform: none;
            margin: 0;
            transition: none;
            border: 1px solid #bfbfbf;
          }
          .nav-item:hover + .nav-item {
            transform: none;
            margin: 0;
            transition: none;
            border: 1px solid #bfbfbf;
          }
        }
        .tab-content {
          margin-top: 10px;
          .tab-pane {
            h3 {
              font-size: 14px;
              margin-bottom: 20px;
            }
            p {
              font-size: 14px;
            }
            .show-Img {
              // height: ;
              img {
                margin-left: 6%;
              }
              .pageUp,
              .pageDown {
                // top: 15%;
                transform: scale(0.5);
              }
            }
          }
        }
      }
    }
  }
  .wisdom-gov .tabBox .nav-pills {
    margin-right: 0px;
  }
  .wisdom-gov .tabBox .nav-pills .nav-item {
    width: 280px;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .wisdom-gov {
    padding: 60px 0 150px;
  }
  .nav {
    .nav-item {
      a {
        padding: 0 15px;
        font-size: 16px;
      }
    }
  }
  .tab-content {
    // padding: 0 50px;
    .tabBox {
      margin-top: 30px;
      .tabs {
        width: 100%;
        .nav-pills {
          margin: 0;
          overflow: hidden;
          background: none;
          border-right: 1px solid #bfbfbf;
          .nav-item {
            width: calc(100vw - 100px);
          }
          .nav-item:hover {
            transform: none;
            margin: 0;
            transition: none;
            border: 1px solid #bfbfbf;
          }
          .nav-item:hover + .nav-item {
            transform: none;
            margin: 0;
            transition: none;
            border: 1px solid #bfbfbf;
          }
        }
        .tab-content {
          margin-top: 20px;
          .tab-pane {
            h3 {
              font-size: 16px;
            }
            p {
              font-size: 14px;
            }
          }
        }
        .el-carousel {
          height: 220px;
          .el-carousel__container {
            height: 100%;
          }
        }
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .wisdom-gov {
    padding: 60px 0px 200px;
  }
  .nav {
    .nav-item {
      a {
        padding: 0 15px;
        font-size: 19px;
      }
    }
  }
  .tab-content {
    // padding: 0 50px;
    .tabBox {
      margin-top: 30px;
      .tabs {
        width: 100%;
        .nav-pills {
          margin: 0 auto;
          overflow: hidden;
          background: none;
          border-right: 1px solid #bfbfbf;
          .nav-item {
            width: calc(100vw - 200px);
          }
          .nav-item:hover {
            transform: none;
            margin: 0;
            transition: none;
            border: 1px solid #bfbfbf;
          }
          .nav-item:hover + .nav-item {
            transform: none;
            margin: 0;
            transition: none;
            border: 1px solid #bfbfbf;
          }
        }
        .tab-content {
          margin-top: 30px;
          .tab-pane {
            h3 {
              font-size: 19px;
            }
            p {
              font-size: 16px;
            }
          }
        }
        .el-carousel {
          height: 280px;
          .el-carousel__container {
            height: 100%;
          }
        }
      }
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .wisdom-gov {
    padding-bottom: 200px;
  }
  .nav {
    .nav-item {
      a {
        padding: 0 15px;
        font-size: 20px;
      }
    }
  }
  .tab-content {
    // padding: 0 50px;
    .tabBox {
      margin-top: 30px;
      .tabs {
        width: 100%;
        .nav-pills {
          margin: 0 auto;
          overflow: hidden;
          background: none;
          border-right: 1px solid #bfbfbf;
          .nav-item {
            width: calc(100vw - 300px);
          }
          .nav-item:hover {
            transform: none;
            margin: 0;
            transition: none;
            border: 1px solid #bfbfbf;
          }
          .nav-item:hover + .nav-item {
            transform: none;
            margin: 0;
            transition: none;
            border: 1px solid #bfbfbf;
          }
        }
        .tab-content {
          margin-top: 30px;
          .tab-pane {
            h3 {
              font-size: 21px;
            }
            p {
              font-size: 16px;
            }
          }
        }
        .el-carousel {
          height: 340px;
          .el-carousel__container {
            height: 100%;
          }
        }
      }
    }
  }
}
@media (min-width: 1200px) {
}
</style>
